export async function copyToClipBoard(text: string, suppressError: boolean = true): Promise<boolean> {
    try {
        if (navigator.clipboard != null) { // Chrome or FF with polyfills
            await navigator.clipboard.writeText(text);
            return true;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((window as any).clipboardData != null) { // Internet Explorer
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).clipboardData.setData('Text', text);
            return true;
        }

        throw new Error('no browser api available');
    } catch (e) {
        if (!suppressError) {
            throw e;
        }
        return false;
    }
}
